var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 12 } },
    [
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c("card-indicator", {
            attrs: {
              title: "Total",
              value: 0,
              typeIconBox: "primary",
              type: "type-min"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c("card-indicator", {
            attrs: {
              title: "Ativos",
              value: 0,
              typeIconBox: "success",
              type: "type-min"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c("card-indicator", {
            attrs: {
              title: "Inativos",
              value: 0,
              typeIconBox: "warning",
              type: "type-min"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c("card-indicator", {
            attrs: {
              title: "Inadiplentes",
              value: 0,
              typeIconBox: "danger",
              type: "type-min"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-051ff139", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051ff139","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorIndicators.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-051ff139","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorIndicators.vue
// module chunks = 2